export default __webpack_public_path__ + "static/media/9lb.899d7184.webp";